import React from "react";
import { Portal } from "react-portal";
import { CSSTransition } from "react-transition-group";

import useNotification from "@/hooks/useNotification";

import styles from "./styles.module.css";
import { View } from "./View";

export const Notification = () => {
  const { contents, isNotificationVisible, dismissNotification } =
    useNotification();
  return (
    <Portal>
      <CSSTransition
        in={isNotificationVisible}
        unmountOnExit
        classNames={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          exit: styles.exit,
          exitActive: styles.exitActive,
        }}
        addEndListener={(node, done) => {
          const notificationEl = node.querySelector("#notification");
          notificationEl.addEventListener("transitionend", done, false);
        }}
      >
        <View dismissNotification={dismissNotification}>{contents}</View>
      </CSSTransition>
    </Portal>
  );
};
